"use client";

import { H } from "@ecco/ui/a11y-heading";
import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { Collapse } from "@ecco/ui/collapse";
import { useState } from "react";
import { buttonStyle, iconStyle, wrapperStyle } from "./ExpandableFieldStyle";
import { useBreakpoint } from "@ecco/ui/use-breakpoint";

const NUMBER_OF_LINES = 9;

type ExpandableFieldProps = {
    title: string;
    content: string;
};

export const ExpandableField = ({ title, content }: ExpandableFieldProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const onClick = () => setIsOpen(!isOpen);
    const isDesktop = useBreakpoint("sm");
    const isMobile = !isDesktop;

    return (
        <Flex sx={wrapperStyle}>
            <Button sx={buttonStyle} variant="ghost" onClick={onClick}>
                <H size="h5">{title}</H>
                <ECCOIcon {...iconStyle(isOpen)} name="chevron" />
            </Button>
            <Collapse startingHeight={isMobile ? "10rem" : "12rem"} in={isOpen}>
                <Text noOfLines={!isOpen && NUMBER_OF_LINES}>{content}</Text>
            </Collapse>
        </Flex>
    );
};
